import { useState } from "react";
import VerifiedQuestionTable from "./VerifiedQuestionTable";
import DocumentTable  from "./DocumentTable";
import DomainTable from "./DomainManagement";
import { Box, Container, Stack, Tab, Tabs, useTheme } from "@mui/material";
import CustomTabPanel from "../../components/CustomTabPanel/CustomTabPanel";
import { AdminPanelTabs } from "./AdminPanelTabs";
type Props = {};

function a11yProps(index: number) {
    return {
        id: `admin-tab-${index}`,
        "aria-controls": `admin-tabpanel-${index}`
    };
}

const Admin = (props: Props) => {
    const [tab, setTab] = useState("verifiedQuestionsTable");
    const theme = useTheme();

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };

    return (
        <Container maxWidth="xl">
            <h1>Admin Dashboard</h1>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={tab === "" ? false : tab} onChange={handleChange} aria-label="admin tabs">
                        <Tab label="Verified Questions Table" value={AdminPanelTabs.VerifiedQuestionsTable} {...a11yProps(0)} />
                        <Tab label="Documents" value={AdminPanelTabs.DocumentsTable} {...a11yProps(1)} />
                        <Tab label="Domains" value={AdminPanelTabs.DomainTable} {...a11yProps(2)} />
                    </Tabs>
                </Box>
                {tab === AdminPanelTabs.VerifiedQuestionsTable && (
                    <CustomTabPanel value={"verifiedQuestionsTable"} tabType={AdminPanelTabs.VerifiedQuestionsTable}>
                        <Stack direction="column" spacing={2}>
                            <Stack direction="column" spacing={1}>
                                <VerifiedQuestionTable />
                            </Stack>
                        </Stack>
                    </CustomTabPanel>
                )}
                {tab === AdminPanelTabs.DocumentsTable && (
                    <CustomTabPanel value={"documentsTable"} tabType={AdminPanelTabs.DocumentsTable}>
                        <Stack direction="column" spacing={2}>
                            <Stack direction="column" spacing={1}>
                                <DocumentTable />
                            </Stack>
                        </Stack>
                    </CustomTabPanel>
                )}
                {tab === AdminPanelTabs.DomainTable && (
                    <CustomTabPanel value={"domainTable"} tabType={AdminPanelTabs.DomainTable}>
                        <Stack direction="column" spacing={2}>
                            <Stack direction="column" spacing={1}>
                                <DomainTable />
                            </Stack>
                        </Stack>
                    </CustomTabPanel>
                )}
            </Box>
        </Container>
    );
};

export default Admin;
